import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Icon from '../icons/icon'
import pickBy from 'lodash/pickBy'

const SocialButtons = props => {
  const { light, socialMedia } = props
  const socialMediaFiltered = pickBy(socialMedia)
  const renderButtons = Object.keys(socialMediaFiltered).map((sm, i) => (
    <li className='social-item' key={i}>
      <a href={`http://${socialMedia[sm]}`}>
        <Icon name={`social-${sm}`} />
      </a>
    </li>
  ))
  return (
    <ul
      className={classNames({
        social: true,
        light: light
      })}
    >
      {renderButtons}
    </ul>
  )
}

SocialButtons.defaultProps = {
  socialMedia: {}
}

SocialButtons.propTypes = {
  light: PropTypes.bool,
  socialMedia: PropTypes.shape({
    facebook: PropTypes.string,
    twitter: PropTypes.string,
    instagram: PropTypes.string,
    google: PropTypes.string
  })
}

export default SocialButtons



// WEBPACK FOOTER //
// ./src/ui/social/social-buttons.js